import { render, staticRenderFns } from "./AppLanding.vue?vue&type=template&id=8d714768&"
import script from "./AppLanding.vue?vue&type=script&lang=ts&"
export * from "./AppLanding.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports